import { render, staticRenderFns } from "./language-switcher.component.vue?vue&type=template&id=a88ff79c&scoped=true&"
import script from "./language-switcher.component.vue?vue&type=script&lang=js&"
export * from "./language-switcher.component.vue?vue&type=script&lang=js&"
import style0 from "./language-switcher.component.vue?vue&type=style&index=0&id=a88ff79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88ff79c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VListItemTitle,VMenu})
